import React from 'react';

import { RootState } from 'app/reducer';
import { useSelector } from 'react-redux';
import DropdownSelect from 'seedly-component-library/dropdown-select';
import { getCurrentCategorySlug } from 'app/selectors/productSelector';
import mixpanel, { trackedEvents } from 'app/utils/mixpanel';

interface OwnProps {
  onChange?: (item: { title: string; value: string }) => void;
}

const ProductCategorySelect = (props: OwnProps) => {
  const { onChange } = props;
  const productCategories = useSelector(
    (state: RootState) => state.product.productCategories,
  );
  const categorySlug = useSelector(getCurrentCategorySlug);

  const items = productCategories
    .flatMap(cat => (cat.children.length > 0 ? cat.children : cat))
    .map(cat => ({ title: cat.name, value: cat.slug }));

  const allCategoriesItem = {
    title: 'All Categories',
    value: '',
  };

  const defaultItem = categorySlug
    ? items.find(item => item.value === categorySlug)
    : allCategoriesItem;

  return (
    <div className="w-full lg:w-max">
      <DropdownSelect
        variant="white"
        isBlock
        menuWidthClass="w-full"
        items={[allCategoriesItem, ...items]}
        defaultSelectedItem={defaultItem}
        handleSelectedItemchange={({ selectedItem }) => {
          if (onChange) {
            mixpanel.track(trackedEvents.SignUpBonus, {
              param:
                selectedItem.value === ''
                  ? 'all_categories'
                  : selectedItem.value.replace(/-/g, '_'),
            });
            onChange({ title: selectedItem.title, value: selectedItem.value });
          }
        }}
      />
    </div>
  );
};

export default ProductCategorySelect;
